<template>
  <div>
    <div class="row">
      <div
        v-for="(item, index) in results"
        :key="index"
        class="col-lg-3 col-md-4 col-12 benjamin-moore-list mb-4"
        @click="openPreview(item)"
      >
        <div class="row">
          <div class="col-md-12">
            <div
              class="paint"
              :style="{ backgroundColor: '#' + item.Hex }"
            />
          </div>
          <div class="col-md-12">
            <div class="paint-description">
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <p class="paint-text"><b>{{ item.ColorName }}</b></p>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <div class="d-flex justify-content-between">
                    <p class="paint-text mt-2">{{ item.ColorNumber }}</p>
                    
                    <span
                      class="mr-2 png-icon png-icon-icons-glyph--k-my-basket"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal show fade benjamin-preview" v-if="showModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <button class="wf-modal-button-close btn button-full" type="button" @click="hideModal('benjamin-add-to-cart')">
              <span class="png-icon png-icon-icons-symbols--k-txtclose " aria-label="Close modal"></span>
            </button>
            <div class="row">
              <div class="col-12 col-lg-4">
                <div>
                  <div
                    class="paint"
                    :style="{ backgroundColor: '#' + selectedColor.Hex }"
                  />
                </div>
              </div>
              <div class="col-12 col-lg-8">
                <div>
                  <span class="color-name">
                    {{ selectedColor.ColorName }}
                  </span>
                </div>
                <div>
                  <span class="font-1rem font-weight-bold mr-1">{{ $resourceString["benjaminMoore.Preview.Lvr"] }}:</span>
                  <span class="font-1rem">{{ selectedColor.Lrv }}</span>
                </div>
                <div>
                  <span class="font-1rem font-weight-bold mr-1">{{ $resourceString["benjaminMoore.Preview.ProductType"] }}: </span>
                  <span class="font-1rem text-capitalize">paint</span>
                </div>
                <div>
                  <span class="font-1rem font-weight-bold mr-1">{{ $resourceString["benjaminMoore.Preview.ColorNumber"] }}:</span>
                  <span class="font-1rem"> {{ selectedColor.ColorNumber }} </span>
                </div>
                <div class="font-size-small blue-regular">
                  <span class="png-icon png-icon-icons-symbols--k-txtinfo"></span>
                  <span class="info-text font-1rem">{{ $resourceString["benjaminMoore.Preview.Info"] }}</span>
                </div>

                <button @click="addPaintToBasket()"
                :disabled=OrderSampleEnabled
                   class="btn btn-primary float-right mt-2">
                  {{ $resourceString["benjaminMoore.Preview.Order"] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["results"],
  data() {
    return {
      selectedColor: [],
      showModal: false
    };
  },
  created(){
    this.isOrderSampleEnabled()
  },
  computed: {
    ...mapGetters({
      OrderSampleEnabled :"productDetail/getisOrderSampleEnabled"

    })
  },
  methods: {
    ...mapActions({
      addToCart: "newBasketPage/addToCart",
      isOrderSampleEnabled:"productDetail/isOrderSampleEnabled"

    }),
    openPreview: function(item) {
      this.selectedColor = item;
      this.showModal = true;
    },
    hideModal(name) {
      this.showModal = false;
    },
    addPaintToBasket() {
      let data = {
        sellingStyleNumber: "I0581",
        colorNumber: this.selectedColor.EcommerceColorNumber,
        vehicleId: null,
        quantity: 1,
        saveForLater: false
      };
      this.addToCart(data);
    }
  }
};
</script>